<template>
  <v-card :color="cardcolor" :class="textcolor" v-ripple="{ class: 'grey--text' }" @click.native="navigate" hover
    height="100%">
    <v-card-title primary-title>
      <h3 class="headline pa-1">
        <v-icon dark x-large v-if="!loading">{{ icon }}</v-icon>
        <v-progress-circular v-else indeterminate color="white"></v-progress-circular>
        {{ title }}
      </h3>
      <v-card-text class="hidden-xs-only">{{ subtitle }}</v-card-text>
    </v-card-title>
  </v-card>
</template>

<script>
export default {
  name: 'MainPageButton',
  props: {
    title: String,
    subtitle: String,
    icon: String,
    route: String,
    cardcolor: {
      type: String,
      default: 'green darken-1'
    },
    textcolor: {
      type: String,
      default: 'white--text'
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    navigate: function () {
      if (this.route === 'ExportExcel' || this.route === undefined) {
        this.$emit('exportExcel')
      } else if (this.$route.name !== this.route) {
        if (this.route !== null && this.$route.name !== this.route) {
          console.log('navigate to ' + this.route)
          this.$router.push({ name: this.route })
        }
      }
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/common/MainPageButton.vue